import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';

import { createImageThumbnail } from './createImageThumbnail';
import { MEDIA_TYPES } from '../../constants';
import { detectTypeRequest } from './detectType';

const formatRequest = async ({ fieldValues, attachments, actionType, dropdownOptions }) => {
  const id = uuidv4();

  const { imageAttachments, fileAttachments } = attachments.reduce(
    (acc, attachment) => {
      if (!attachment) return acc;

      const type = detectTypeRequest(attachment);
      if (type === MEDIA_TYPES.IMAGE) {
        acc.imageAttachments.push(attachment);
      } else {
        acc.fileAttachments.push(attachment);
      }
      return acc;
    },
    { imageAttachments: [], fileAttachments: [] },
  );

  const formattedImageAttachments = await Promise.all(
    imageAttachments.map(async (attachment) => {
      const thumbnail = await createImageThumbnail(attachment);
      return thumbnail;
    }),
  );

  const formattedFileAttachments = fileAttachments.map((attachment) => {
    return {
      id: uuidv4(),
      name: attachment.name,
      type: MEDIA_TYPES.APPLICATION,
    };
  });

  const formattedFieldValues = Object.entries(fieldValues).reduce((acc, [key, value]) => {
    if (dropdownOptions[key]) {
      acc[key] = dropdownOptions[key].find((option) => option.value === value);
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});

  return {
    id: id,
    actionType: actionType,
    time: dayjs().format(),
    attachments: [...formattedImageAttachments, ...formattedFileAttachments],
    fieldValues: formattedFieldValues,
  };
};

export default formatRequest;
